// extracted by mini-css-extract-plugin
export var cardLayout = "_98-1";
export var paginationContainer = "_98-0";